import React  from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import CheckCircleIcon from '@material-ui/icons/Check';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import EditIcon from '@material-ui/icons/Edit';
import CreateIcon from '@material-ui/icons/Create';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import { GET_STUDENT_WORKSHEETS } from 'graphql/student/milestones';
import ListSubheader from '@material-ui/core/ListSubheader';
import Helmet from "react-helmet";

const STATUS_COLOR = {
  inprogress: '#FFAD0F',
  done: '#8ED76E',
  new: '#0F78FF',
};

const getIcon = (status) => {
  if (status === 'done') return <CheckCircleIcon />;
  if (status === 'inprogress') return <CreateIcon />;
  return <HourglassEmptyIcon />;
};

const ExercisesList = ({ prefix, student, match: { params } }) => {
  const { moduleId } = params;
  const { loading, error, data } = useQuery(GET_STUDENT_WORKSHEETS, {
    variables: { userId: student.user_id },
  });

  if (loading) {
    return (
      <div>
        <LinearProgress />
      </div>
    );
  }

  if (error) {
    return <div>Error</div>;
  }

  prefix = prefix === undefined ? `/students/${student.user_id}` : prefix;

  const modules = data?.modules.map((i) => (
    <ListItem
      divider
      button
      key={i.id}
      selected={i.id === Number(moduleId)}
      component={Link}
      to={`${prefix}/exercises/${i.id}`}
    >
      <ListItemAvatar>
        <Avatar style={{ backgroundColor: STATUS_COLOR.inprogress }}>
          {i.name[0]}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={i.name}
      />
      <ListItemSecondaryAction>
        <ArrowForwardIosIcon />
      </ListItemSecondaryAction>
    </ListItem>
  ));

  const exercises = data?.modules
    .find((m) => m.id === Number(moduleId))
    ?.exercises
    .filter(e => e.student_milestone_exercises.length)
    .map((e) => (
      <ListItem
        divider
        button
        key={e.id}
        component={Link}
        to={`${prefix}/exercises/${e.student_milestone_exercises[0].id}/view`}
      >
        <ListItemAvatar>
          <Avatar style={{ backgroundColor: STATUS_COLOR[e.student_milestone_exercises[0].status] }}>
            {getIcon(e.student_milestone_exercises[0].status)}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={e.name}
          secondary={`approx. ${e.duration} min`}
        />
        {e.tags && <Chip size="small" label={e.tags} />}
      </ListItem>
    ));

  return (
    <Grid container spacing={3}>
      <Helmet title="Exercises" />
      <Grid item md={5}>
        <List
          component={Paper}
          disablePadding
          subheader={<ListSubheader>Modules</ListSubheader>}
        >
          {modules}
        </List>
      </Grid>
      <Grid item md={7}>
        {exercises ? (
          <List
            component={Paper}
            disablePadding
            subheader={<ListSubheader>Exercises</ListSubheader>}
          >
            {exercises}
          </List>
        ) : (
          <Typography color="textSecondary" variant="subtitle2">
            Select a module
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default ExercisesList;
